import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { API_END_POINT } from "@app/core/constants/app-constant";

@Injectable({
  providedIn: "root",
})
export class ApiUploadService {
  constructor(private apiSvc: ApiService, private http: HttpClient) {}

  getSignedUrl(values: any): Promise<any> {
    return this.apiSvc.post(API_END_POINT.signedURL, values);
  }

  uploadFile(file, signedUrl): Promise<any> {
    return this.http.put(signedUrl, file, {}).toPromise();
  }

  confirmFileUpload(values: any): Promise<any> {
    return this.apiSvc.post(API_END_POINT.confirmFileUpload, values);
  }
}
